<div #overlayEl
     class="ft-overlay-modal ft2"
     [class.-open]="isOpen"
     [ngClass]="'-theme_' + theme">
    <div class="ft-overlay-modal_backdrop" (click)="onBackdropClick()"></div>
    <div class="ft-overlay-modal_dialog">
        <button *ngIf="hasCloseButton" type="button" class="ft2-btn-close -fixed" (click)="close()"></button>
        <div class="ft-overlay-modal_body">
            <ng-container *ngIf="prerender || isOpen">
                <ng-content></ng-content>
            </ng-container>
        </div>
    </div>
</div>
